import api from './axiosInstance'

export default {
    signup(payload) {
        return api.post('signup', payload);
    },
    verifyEmail(payload) {
        return api.post('verify-email', payload);
    },
}